export default __webpack_public_path__ + "static/media/login-registration-bg.0a5b9c5b.jpg";